import { UPDATE_IS_AVAILABLE } from "../../actions/actionTypes/updates";

export function updates(state = {}, action: any) {
  switch (action.type) {
    case UPDATE_IS_AVAILABLE:
      return {
        ...state,
        availableUpdateInfo: action.payload,
      };
    default:
      return state;
  }
}
